import React from "react";
import { Link } from "react-router-dom";
import bgImage from '../assets/images/bg.jpeg';
import "../styles/auth.css";

const TermsAndConditions = () => {
  return (
    <div 
      className="terms-page" 
      style={{
        backgroundImage: `url(${bgImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed',
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: '60px 20px 140px 20px'
      }}
    >
      <div 
        className="content-container p-5 rounded" 
        style={{ 
          width: '95%',
          maxWidth: '1200px',
          backgroundColor: 'rgba(255, 255, 255, 0.95)',
          border: '3px solid #000',
          boxShadow: 'none'
        }}
      >
        <h1 className="text-center mb-5" style={{ color: '#000', fontWeight: '900', fontSize: '2.5rem' }}>
          LOREM IPSUM TERMS & CONDITIONS
        </h1>

        <div className="terms-text" style={{ color: '#000', lineHeight: '1.8' }}>
          <div className="row">
            {/* Left Column */}
            <div className="col-md-6">
              <section className="mb-4">
                <h4 style={{ fontWeight: '900', textTransform: 'uppercase' }}>1. Acceptance of Terms</h4>
                <p style={{ fontWeight: '700', fontSize: '1.1rem' }}>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit.
                </p>
              </section>

              <section className="mb-4">
                <h4 style={{ fontWeight: '900', textTransform: 'uppercase' }}>2. User Responsibilities</h4>
                <p style={{ fontWeight: '700', fontSize: '1.1rem' }}>
                  Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque.
                </p>
              </section>
            </div>

            {/* Right Column */}
            <div className="col-md-6">
              <section className="mb-4">
                <h4 style={{ fontWeight: '900', textTransform: 'uppercase' }}>3. Limitations of Liability</h4>
                <p style={{ fontWeight: '700', fontSize: '1.1rem' }}>
                  Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum.
                </p>
              </section>

              <section className="mb-4">
                <h4 style={{ fontWeight: '900', textTransform: 'uppercase' }}>4. Governing Law</h4>
                <p style={{ fontWeight: '700', fontSize: '1.1rem' }}>
                  Quis autem vel eum iure reprehenderit qui in ea voluptate velit esse quam nihil molestiae consequatur, vel illum qui dolorem eum fugiat quo voluptas nulla pariatur? At vero eos et accusamus et iusto odio.
                </p>
              </section>
            </div>
          </div>
        </div>

      
      </div>

      {/* Footer Links - Bold, Black, and Close Together */}
     <div className="login-footer-links w-100 text-center position-absolute" style={{ bottom: '1in' }}>
             <div className="d-flex justify-content-center align-items-center gap-2">
               <Link to="https://blessedbuilderssoberliving.org/about-us" className="footer-link" target="_blank">About Us</Link>
               <span className="footer-separator">|</span>
               <Link to="https://blessedbuilderssoberliving.org/contact-us" className="footer-link" target="_blank">Contact Us</Link>
               <span className="footer-separator">|</span>
             {/*  <Link to="#" className="footer-link">Terms & Conditions</Link>
               <span className="footer-separator">|</span> */}
               <Link to="/privacy-policy" className="footer-link">Privacy Policy</Link>
             </div>
           </div>
    </div>
  );
};

const footerLinkStyle = {
  color: '#000000',
  fontWeight: '900',
  textDecoration: 'none',
  fontSize: '1.1rem',
  padding: '0 5px'
};

const separatorStyle = {
  color: '#000000',
  fontWeight: '900'
};

export default TermsAndConditions;